import { el, list, setChildren } from 'redom';

import MessageDisplay from './message-display';

import conversationMessageTypes from '../../constants/conversation-message-types';

class MessageGroup {

  constructor(configuration) {

    this.messagesDisplay = list('ul.inbox-message-group-messages.helptap-list', MessageDisplay, '_id', configuration);

    this.el = el('li.inbox-message-group-main', [this.messagesDisplay]);

  }

  update(messageGroup) {

    if (messageGroup.type === conversationMessageTypes.INBOUND) {
      setChildren(this.el, [this.messagesDisplay]);
      this.el.classList.add('inbound');
      this.el.classList.remove('outbound');
    } else {
      setChildren(this.el, [this.messagesDisplay]);
      this.el.classList.add('outbound');
      this.el.classList.remove('inbound');
    }

    if (messageGroup.conversation.deliveryChannel === 'EMAIL') {
      this.el.classList.add('email-message');
    }

    this.messagesDisplay.update(messageGroup.messages, messageGroup);

  }

}

export default MessageGroup;